'use strict'

export let norwegian_product={
  Overview: {
    fields: {
      summary: {
        help: "Har noen viktige milepæler bare passert, eller er det noen i nær fremtid? Er det noen nylige suksesser eller gjennomslag? Hva er for tiden de viktigste utfordringene? Hva er den generelle helsetilstanden?",
        description: "Beskriv den overordnede status. Anta at leseren ikke har lest den forrige rapporten eller er kjent med detaljene i hva som skal leveres."
      },
      performedAchivements: {
        help: "Hvilket arbeid er utført eller fullført denne perioden? Hvilke oppdateringer eller operasjonelle forbedringer var planlagt å bli ferdig i perioden? Er det noen planlagte oppgaver som ikke ble utført eller fullført i denne perioden? Har det vært utført noen korrigerende tiltak i perioden?",
        description: "Beskriv arbeidet som er utført og målene som er oppnådd i denne perioden"

      },
      plannedAchivements: {
        help: "Hvilket arbeid vil bli gjennomført eller fullført i kommende periode? Hvilke oppdateringer eller operasjonelle forbedringer er planlagt å bli ferdig i kommende periode? Er det planlagt korrigerende tiltak i den kommende perioden?",
        description: "Beskriv arbeidet og målene som er fastsatt for neste periode"
      },

      benefits: {
        help: "Leverer dette produktet ønsket avkastningen på investeringen? Hvis ikke, hva er forskjellen og hvorfor? Er eventuelle nye gevinster lagt til eller fjernet fra begrunnelsen?",
        description: "Beskriv hvordan produktet fører til forventet eller planlagt verdiskapning"
      },
      time: {
        help:"Hva er den siste prognosen for å fullføre de planlagte oppdateringenene og operasjonelle forbedringene, og hvordan er det sammenlignet med den kommuniserte langtidsplanen?",
        description: "Beskriv hvordan fremdriften er i forhold til avtalt langtidsplan"
      },
      cost: {
        help:"Hva er planlagt løpende kostnad for utvikling og vedlikehold? Hva er det forventet å bli brukt på kort sikt og på lang sikt? Hva er i øyeblikket godkjente kostnadsrammer?",
        description: "Beskriv beløp på løpende kostnad og hvordan den er i forhold til planlagt kostnad"
      },

      quality: {
        help:"Er interne og eksterne kunder og brukere tilfreds med tilstanden til produktet? Er funksjonalitet, stabilitet, sikkerhet og pålitelighet god nok?",
        description: "Beskriv i hvilken grad vi nå oppfyller kunders/brukeres forventninger til funksjonalitet, stabilitet, sikkerhet og pålitelighet"
      },
      scope: {
        help:"Har vi det vi trenger for å promotere, selge, levere og støtte dette produktet på en god måte? Dekker produktet de nødvendige funksjonelle områdene?",
        description: "Beskriv i hvilken grad produktet dekker det som trengs av funksjonelle områder og operasjonell effektivitet"
      },

      risk: {
        help:"Hva er det nåværende risikonivået og hvordan samsvarer det med interessentene risikovillighet? Hva er de viktigste risikoene og hvilke tiltak er utført?",
        description: "Beskriv hvordan dagens risikonivå er sammenlignet med den avtalte risikoappetitten"
      }
    }
  },
};



// WEBPACK FOOTER //
// ./views/progress/labels/norwegian_product.js